module.exports = __webpack_public_path__ + "static/media/sort.4d18d9e4.svg";